import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useKcAuthStore } from '@/stores/kcAuth'

const Names = {
  fr: 'profile',
  en: 'profile'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: '/profile:afterProfile(.*)',
  component: () => import('@pageRemote/Profile/Profile.vue'),
  beforeEnter: async (to, from, next) => {
    if (!useKcAuthStore().isUserLogged) {
      await useKcAuthStore().login(to.path, to.query)
    }
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next()
  }
}

export { Config }
